import { calculateTimeDifference, calculateFutureTime } from "./countdown-html";
import { toRGBA } from "../parser/utils";
import classNames from "classnames";
import { useEffect, useRef } from "react";
import { useUpdate } from "ahooks";

export const CLOCK_ACT_WIDTH = 608;
export const CLOCK_ACT_HEIGHT = 128;

const SimpleText = ({ datetimeUnits, labelColor, hideLabel, labelArr }) => {
  const labelStyle = {
    color: toRGBA(labelColor),
    display: hideLabel ? "none" : "block",
  };

  return (
    <div style={{ color: toRGBA(labelColor) }} className="rip-mm-cd-wrapper face-text">
      {datetimeUnits.showDays && (
        <div className="rip-mm-cd-text-group">
          <div className="rip-mm-cd-text-container">
            <div className="rip-mm-cd-text">{datetimeUnits.days[0]}</div>
            <div className="rip-mm-cd-text">{datetimeUnits.days[1]}</div>
          </div>
          <div style={labelStyle} className="rim-mm-cd-label">
            {labelArr[0]}
          </div>
        </div>
      )}

      {datetimeUnits.showHours && (
        <div className="rip-mm-cd-text-group">
          <div className="rip-mm-cd-text-container">
            <div className="rip-mm-cd-text">{datetimeUnits.hours[0]}</div>
            <div className="rip-mm-cd-text cd-colon">
              {datetimeUnits.hours[1]}
            </div>
          </div>
          <div style={labelStyle} className="rim-mm-cd-label">
            {labelArr[1]}
          </div>
        </div>
      )}

      <div className="rip-mm-cd-text-group">
        <div className="rip-mm-cd-text-container">
          <div className="rip-mm-cd-text">{datetimeUnits.minutes[0]}</div>
          <div className="rip-mm-cd-text cd-colon">
            {datetimeUnits.minutes[1]}
          </div>
        </div>
        <div style={labelStyle} className="rim-mm-cd-label">
          {labelArr[2]}
        </div>
      </div>
      <div className="rip-mm-cd-text-group">
        <div className="rip-mm-cd-text-container">
          <div className="rip-mm-cd-text">{datetimeUnits.seconds[0]}</div>
          <div className="rip-mm-cd-text">{datetimeUnits.seconds[1]}</div>
        </div>
        <div style={labelStyle} className="rim-mm-cd-label">
          {labelArr[3]}
        </div>
      </div>
    </div>
  );
};

const FlipCard = ({
  datetimeUnits,
  labelColor,
  hideLabel,
  labelArr,
  cardColor,
}) => {
  const cardStyle = {
    color: toRGBA(labelColor),
    backgroundColor: toRGBA(cardColor),
  };

  const labelStyle = {
    color: toRGBA(cardColor),
    display: hideLabel ? "none" : "block",
  };

  return (
    <>
      {datetimeUnits.showDays && (
        <div className="rip-mm-cd-group">
          <div className="rip-mm-cd-flip-container">
            <ul className="rip-mm-cd-flip d1">
              <li className="rip-mm-cd-aa">
                <div className="up">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.days[0]}
                  </div>
                </div>
                <div className="down">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.days[0]}
                  </div>
                </div>
              </li>
            </ul>
            <ul className="rip-mm-cd-flip d2">
              <li className="rip-mm-cd-aa">
                <div className="up">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.days[1]}
                  </div>
                </div>
                <div className="down">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.days[1]}
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div style={labelStyle} className="rim-mm-cd-label">
            {labelArr[0]}
          </div>
        </div>
      )}

      {datetimeUnits.showHours && (
        <div className="rip-mm-cd-group">
          <div className="rip-mm-cd-flip-container">
            <ul className="rip-mm-cd-flip h1">
              <li className="rip-mm-cd-aa">
                <div className="up">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.hours[0]}
                  </div>
                </div>
                <div className="down">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.hours[0]}
                  </div>
                </div>
              </li>
            </ul>
            <ul className="rip-mm-cd-flip h2">
              <li className="rip-mm-cd-aa">
                <div className="up">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.hours[1]}
                  </div>
                </div>
                <div className="down">
                  <div className="shadow"></div>
                  <div style={cardStyle} className="inn">
                    {datetimeUnits.hours[1]}
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div style={labelStyle} className="rim-mm-cd-label">
            {labelArr[1]}
          </div>
        </div>
      )}

      <div className="rip-mm-cd-group">
        <div className="rip-mm-cd-flip-container">
          <ul className="rip-mm-cd-flip m1">
            <li className="rip-mm-cd-aa">
              <div className="up">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.minutes[0]}
                </div>
              </div>
              <div className="down">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.minutes[0]}
                </div>
              </div>
            </li>
          </ul>

          <ul className="rip-mm-cd-flip m2">
            <li className="rip-mm-cd-aa">
              <div className="up">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.minutes[1]}
                </div>
              </div>
              <div className="down">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.minutes[1]}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style={labelStyle} className="rim-mm-cd-label">
          {labelArr[2]}
        </div>
      </div>

      <div className="rip-mm-cd-group">
        <div className="rip-mm-cd-flip-container">
          <ul className="rip-mm-cd-flip s1">
            <li className="rip-mm-cd-aa">
              <div className="up">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.seconds[0]}
                </div>
              </div>
              <div className="down">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.seconds[0]}
                </div>
              </div>
            </li>
          </ul>
          <ul className="rip-mm-cd-flip s2">
            <li className="rip-mm-cd-aa">
              <div className="up">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.seconds[1]}
                </div>
              </div>
              <div className="down">
                <div className="shadow"></div>
                <div style={cardStyle} className="inn">
                  {datetimeUnits.seconds[1]}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style={labelStyle} className="rim-mm-cd-label">
          {labelArr[3]}
        </div>
      </div>
    </>
  );
};

export default ({ data }) => {
  let {
    labelFormat,
    dateType,
    fixedDate,
    days,
    hours,
    minutes,
    labelColor,
    cardColor,
    hideLabel,
    timeEndAnimation,
    clockFace,
    autoSize,
    clockWidth,
    paddingTop,
    paddingBottom,
    paddingRight = 0,
    paddingLeft = 0,
  } = data;

  let computedTimestamp = fixedDate;
  if (dateType === "variable") {
    computedTimestamp = calculateFutureTime(days, hours, minutes);
  }

  const datetimeUnits = calculateTimeDifference(computedTimestamp);

  const labelArr = labelFormat.split("-");

  const domRef = useRef();
  let scaleRate = .1;

  if (domRef.current) {
    if (autoSize) {
      const parentWidth = domRef.current?.parentElement.clientWidth;
      scaleRate =
        (parentWidth - paddingLeft - paddingRight) / CLOCK_ACT_WIDTH;
    } else {
      scaleRate = clockWidth / CLOCK_ACT_WIDTH;
    }
  }
  
  const update = useUpdate();
  
  useEffect(() => {
    update();
  }, [scaleRate]);

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
      }}
    >
      <div
        ref={domRef}
        className="rim-mm-cd-scale"
        style={{
          transform: `scale(${scaleRate})`,
          transformOrigin: "top",
          height:
            (hideLabel ? CLOCK_ACT_HEIGHT - 22 : CLOCK_ACT_HEIGHT) * scaleRate,
        }}
      >
        <div
          className={classNames("rip-mm-cd-wrapper", {
            animate__animated: timeEndAnimation !== "none",
            [`animate__${timeEndAnimation}`]: true,
          })}
        >
          {clockFace === "text" ? (
            <SimpleText
              datetimeUnits={datetimeUnits}
              hideLabel={hideLabel}
              labelArr={labelArr}
              labelColor={labelColor}
            />
          ) : (
            <FlipCard
              datetimeUnits={datetimeUnits}
              hideLabel={hideLabel}
              labelArr={labelArr}
              cardColor={cardColor}
              labelColor={labelColor}
            />
          )}
        </div>
      </div>
    </div>
  );
};
